module.exports = __webpack_public_path__ + "img/food1.de99da1e.jpg";